var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "p-1 p-md-0"
  }, [_c('MdmLink', {
    attrs: {
      "url": _vm.urlPrefix,
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink
    }
  }, [_c('mdm-icon', {
    staticClass: "icon icon-item retour",
    attrs: {
      "name": "retours"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.free_return',
      expression: "'footer.free_return'"
    }]
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.estimated_days',
      expression: "'footer.estimated_days'"
    }],
    staticClass: "font-weight-normal"
  }), _vm._v(" "), _vm.isMarketplaceOpen ? _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.return_disclaimer',
      expression: "'footer.return_disclaimer'"
    }],
    staticClass: "return-disclaimer font-weight-normal mt-1"
  }) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };